module.exports = __webpack_public_path__ + "img/26.6135cb01.jpg";